import type { NodeBuilder } from './types';

export const dangerousError = (): NodeBuilder => {
  return {
    type: 'block_node',
    node: getId => ({
      id: getId(),
      type: 'EXTERNAL' as any,
      nodes: [],
      externalData: {
        fields: {},
      },
    }),
  };
};
